<template>
  <v-form ref="promocodeEditForm" v-model="valid">
    <div class="back-btn" @click="$router.push({name: 'promocode-index'})">
      <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M36 27H23.83L29.42 21.41L28 20L20 28L28 36L29.41 34.59L23.83 29H36V27Z" fill="#8C959D"/>
      </svg>
    </div>
    <v-row>
      <v-col  cols="12" sm="5" md="4" xl="3">
        <h1 class="mb-16">{{ promocode.id ? 'Редактировать промокод' : 'Создать промокод'}}</h1>
        <v-tabs v-model="tabLang">
          <v-tab>RU</v-tab>
          <v-tab>UA</v-tab>
        </v-tabs>
        <v-tabs-items v-model="tabLang">
          <v-tab-item :eager="true">
            <v-row>
              <v-col class="pb-0 mb-0">
                <v-text-field
                        v-model="promocode.name"
                        label="Название"
                        :rules="[rules.required]"
                        required
                        outlined
                ></v-text-field>
              </v-col>
            </v-row>
          </v-tab-item>
          <v-tab-item :eager="true">
            <v-row>
              <v-col class="pb-0 mb-0">
                <v-text-field
                        v-model="promocode.name_ua"
                        label="Название"
                        :rules="[rules.required]"
                        required
                        outlined
                ></v-text-field>
              </v-col>
            </v-row>
          </v-tab-item>
        </v-tabs-items>
        <v-select
            label="Где показывать"
            :items="localTypes"
            v-model="promocode.local_type"
            :item-text="item => item.name"
            :item-value="item => item.id"
            outlined>
        </v-select>
        <v-text-field
                v-model="promocode.bonus"
                label="Бонусы"
                outlined
        ></v-text-field>
                <v-select
                        :items="types"
                        :item-text="type => type.name"
                        :item-value="type => type.id"
                        v-model="promocode.is_multiple"
                        label="Тип"
                        outlined
                ></v-select>
        <v-dialog
                ref="timeDialog"
                v-model="timeModal"
                :return-value.sync="promocode.date_to"
                width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
                    v-model="promocode.date_to"
                    label="Срок действия"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    outlined
            ></v-text-field>
          </template>
          <v-date-picker
                  v-model="promocode.date_to"
                  full-width
          >
            <v-spacer></v-spacer>
            <v-btn
                    text
                    color="primary"
                    @click="timeModal = false"
            >
              Cancel
            </v-btn>
            <v-btn
                    text
                    color="primary"
                    @click="$refs.timeDialog.save(promocode.date_to  )"
            >
              OK
            </v-btn>
          </v-date-picker>
        </v-dialog>
          <v-text-field
                  v-model="promocode.code"
                  label="Код"
                  outlined
          ></v-text-field>


        <v-btn :loading="loadingButton" v-if="id" @click="update">Сохранить</v-btn>
        <v-btn :loading="loadingButton" v-else @click="create">Создать</v-btn>
      </v-col>
      <v-snackbar
              v-model="snackbar"
              :timeout="timeout"
              :color="snackbarColor"
              right
              top
      >
        {{ snackbarText }}
      </v-snackbar>
    </v-row>
    <v-row v-if="promocode.id">
      <v-col>
        <promocode-products v-model="promocode" :loading="loading"></promocode-products>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
  // @ is an alias to /src
  import PromocodeService from './../../api/PromocodeService'
  import PromocodeProducts from './Tables/PromocodeProducts'
  import moment from 'moment'

  export default {
    name: 'PromocodeEdit',
    props: {
        id: {
            default: null,
        }
    },
    components: {PromocodeProducts},
    data() {
      return {
        types: [
          {
            id: false,
            name: 'Одноразовый'
          },
          {
            id: true,
            name: 'Многоразовый'
          }
        ],
        snackbar: false,
        timeout: 2000,
        snackbarText: '',
        snackbarColor: '',
        timeModal: false,
        tabLang: '',
        rules: {
          required: value => !!value || 'Нужно заполнить',
          requiredSelect: [(v) => !!v.id || 'Нужно заполнить'],
        },
        valid: true,
        localTypes: [
          {
            id: 'all',
            name: 'Везде',
          },
          {
            id: 'local',
            name: 'Одесса',
          },
          {
            id: 'ukraine',
            name: 'Новая Почта',
          },
        ],
        promocode: {
          name: '',
          name_ua: '',
          code: '',
          bonus: '',
          date_to: null,
          is_multiple: false,
          local_type: 'all',
        },
        loading: true,
        loadingButton: false,
      }
    },
    mounted() {
        this.init()
    },
    methods: {
      validate () {
        this.$refs.promocodeEditForm.validate()

        if(this.promocode.name == '' && this.promocode.name_ua != ''){
          this.tabLang = 0;
        }
        if(this.promocode.name != '' && this.promocode.name_ua == ''){
          this.tabLang = 1;
        }
      },
      init(){
        if(this.id) {
          PromocodeService.get(this.id)
            .then(response => {
              this.promocode = response.data;
              this.loading = false
            });
        }
      },
      update(){
        this.validate()
        if(!this.valid){
          return false
        }
        this.loadingButton = true;
        let formData = this.getData();

        PromocodeService.update(formData).then(response => {
          this.snackbar = true;
          this.snackbarText = 'Промокод успешно обновлен';
          this.snackbarColor = 'success';
        }).catch(error => {
          this.snackbar = true;
          this.snackbarText = 'Ошибка при обновлении промокода';
          this.snackbarColor = 'error';
        }).finally(() => {
          this.loadingButton = false
        })
      },
      create(){
        this.validate()
        if(!this.valid){
          return false
        }
          this.loadingButton = true;
          var formData = this.getData();

          PromocodeService.create(formData).then(response => {
            this.snackbar = true;
            this.snackbarText = 'Промокод успешно создан';
            this.snackbarColor = 'success';
            this.$router.push({ name: 'promocode-edit', params: { id: response.data.id } })
            this.init();
          }).catch(error => {
            this.snackbar = true;
            this.snackbarText = 'Ошибка при создании промокода';
            this.snackbarColor = 'error';
          }).finally(() => {
            this.loadingButton = false
          })
      },
      getData() {
          let formData = new FormData();
          let time = moment('2020-01-01 ' + this.promocode.default_delivery_time).format('HH:mm:ss')

          formData.append('id', this.id);
          formData.append('name', this.promocode.name);
          formData.append('name_ua', this.promocode.name_ua);
          if(this.promocode.date_to){
            formData.append('date_to', this.promocode.date_to);
          }
          formData.append('is_multiple', this.promocode.is_multiple ? 1 : 0);
          formData.append('code', this.promocode.code);
          formData.append('local_type', this.promocode.local_type);

          return formData;
      }
    },
  }
</script>

<style scoped lang="scss">
  .image-placeholder{
    width: 100%;
    height: 100%;
    background-color: #F3F7FC;
    border-radius: 4px;
  }
  .promocode-images .v-image{
    max-height: 374px;
  }
  .promocode{
    position: relative;
    &:before{
      content: "";
      padding-top: 100%;
      display: block;
    }

    .content{
      position: absolute;
      width: 100%;
      left: 0;
      top: 0;
      height: 100%;
      background-color: #F8FBFF;
      border-right-style: 3px;
      .img{
        height: 3.541vw;
        margin-top: .83vw;
      }
      .name{
        margin-top: .72vw;
        text-align: center;
        color: #8C959D;
      }
    }
  }
</style>
